import {addClass, getCookie, makeElement, removeClass, setCookie} from '../../common/Utils';
import { ncBannerOptions } from '../../interface/ICommonbanner';
import {checkCookie} from './checkCookie';

/**
 * @category Commonbanner
 * @description
 * 토스트 배너
 * 메인페이지에서만 노출
 * 닫기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 */

class MainToastLayer {
    isCookieApply: boolean;       
    bannerEl!: HTMLElement;
    el!: HTMLElement;
    constructor(_isMain: boolean = false, _isLauncher:boolean = false, _data:ncBannerOptions) {

        this.isCookieApply = checkCookie();
        let thisIsCookieApply = this.isCookieApply && getCookie(_data.mainToastCookie);

        if( !_isMain || !_data.showMainToastBanner || thisIsCookieApply || _data.showMainFloatingBanner){
            return;
        }

        if ( _isLauncher && !_data.mainToastLauncherShow ) {
            return;
        }

        this.bannerEl = this.template( _data ) ;

        document.body.appendChild( this.bannerEl );
        this.addEvents(_data);

        setTimeout(()=> {
            addClass( this.bannerEl , 'is-show');
        }, 1000);

    }


    template(_data: ncBannerOptions){
        this.el = makeElement( `

            <div class="nc-banner" data-type="toast">
             ${_data.mainToastLink != ''?`
                 <a href="${_data.mainToastLink}" ${_data.mainToastLinkNewWindow ? 'target=_blank' :''} class="nc-banner-link" style="background-image:url('${_data.mainToastBG}')">
                    <div class="nc-banner-inner">
                        <div class="nc-banner-tag">${_data.mainToastLable}</div>
                        <strong class="nc-banner-title-main">${_data.mainToastTitle}</strong>
                        <em class="nc-banner-title-sub">${_data.mainToastSubTitle}</em>
                    </div>
                </a>
            ` : `
               <span class="nc-banner-link" style="background-image:url('${_data.mainToastBG}')">
                    <div class="nc-banner-inner">
                        <div class="nc-banner-tag">${_data.mainToastLable}</div>
                        <strong class="nc-banner-title-main">${_data.mainToastTitle}</strong>
                        <em class="nc-banner-title-sub">${_data.mainToastSubTitle}</em>
                    </div>
                </span>
            `}


                <button class="nc-banner-close"><span class="blind">그만보기</span></button>
            </div>
        ` );

        return this.el;
    }


    addEvents(_data: ncBannerOptions){        
        const dataTypeToast = document.querySelector(".nc-banner[data-type=toast]") as HTMLElement;
        document.querySelector(".nc-banner[data-type=toast] .nc-banner-close")?.addEventListener('click', e =>{
            if(this.isCookieApply){
                setCookie('ncBanner'+_data.mainToastCookie, "true", _data.mainToastCookieExpiredays, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.mainToastCookie, "true", _data.mainToastCookieExpiredays, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.mainToastCookie, "true", _data.mainToastCookieExpiredays, '.plaync.com');
            }
            removeClass( dataTypeToast , 'is-show');
        });
    }

}
export default MainToastLayer;